/* Native Shopify express checkout for complete, unengraved picker selections. */
(function (global) {
  'use strict';
  const document = global.document;
  const wrapper = document.getElementById('steadi-express');
  const form = document.getElementById('steadi-express-form');
  if (!wrapper || !form) return;
  const variantInput = form.querySelector('[name="id"]');
  const properties = form.querySelector('[data-express-properties]');
  if (!variantInput || !properties) return;
  let lastDetail = null, lastSignature = '', groupId = null, commerce = null, commerceConfig = null;

  function hide() {
    wrapper.hidden = true;
    wrapper.inert = true;
    wrapper.setAttribute('aria-hidden', 'true');
    variantInput.disabled = true;
    variantInput.value = '';
    return false;
  }
  function property(name, value, attribution) {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'properties[' + name + ']';
    input.value = String(value);
    if (attribution) input.dataset.attribution = '';
    return input;
  }
  function syncAttribution() {
    // Native wallets create their own checkout. Preserve signed claims as private
    // line properties without delaying or intercepting Shopify's payment flow.
    const attributes = { _storefront: 'steadilabs.com' };
    try {
      const spine = JSON.parse(global.localStorage.getItem('steadi_spine_v1') || 'null');
      if (spine && spine.token) attributes._spine_attribution = spine.token;
      for (const [key, value] of Object.entries(spine && spine.first_touch || {})) attributes['_ft_' + key] = value;
    } catch (_) { /* Storage failure must neither block purchase nor retain stale claims. */ }
    try {
      const experiment = global.SteadiEngravingExperiment;
      const confirmed = experiment && typeof experiment.confirmedAttributes === 'function' ? experiment.confirmedAttributes() : null;
      for (const key of ['_engraving_experiment', '_engraving_arm', '_engraving_visitor', '_engraving_token', '_engraving_assignment']) {
        if (confirmed && typeof confirmed[key] === 'string' && confirmed[key].length && confirmed[key].length <= 1024) attributes[key] = confirmed[key];
      }
    } catch (_) { /* Attribution is optional; the native payment flow remains available. */ }
    for (const input of properties.querySelectorAll('[data-attribution]')) input.remove();
    for (const [key, value] of Object.entries(attributes)) properties.append(property(key, value, true));
  }
  function mount(detail) {
    const host = detail && detail.host, root = detail && detail.root;
    if (!host || !root || host.id !== 'steadi-live-picker' || host.shadowRoot !== root) return false;
    const cta = root.querySelector('#add-to-cart');
    if (!cta) return false;
    let slot = root.querySelector('slot[name="steadi-express"]');
    if (!slot) {
      slot = document.createElement('slot');
      slot.name = 'steadi-express';
    }
    if (cta.nextElementSibling !== slot) cta.after(slot);
    if (wrapper.parentElement !== host) host.append(wrapper);
    return true;
  }
  function blockedByDOM(detail) {
    const root = detail.root;
    // Do not depend solely on a previous callback: an engraving checkbox can
    // change before its change handler updates the shared picker state.
    if (Array.from(root.querySelectorAll('[data-engrave-check]')).some(input => input.checked)) return true;
    const cta = root.querySelector('#add-to-cart');
    return !cta || cta.disabled || root.querySelector('#picker')?.getAttribute('aria-busy') === 'true';
  }
  function sync(detail) {
    lastDetail = detail;
    try {
      if (!mount(detail) || detail.enabled !== true || (typeof detail.isEligible === 'function' && detail.isEligible() !== true) || Number(detail.engravedCount) !== 0 || blockedByDOM(detail)) return hide();
      const config = global.__STEADI_ENGRAVING_CONFIG;
      if (!config || !global.SteadiEngravingCommerce) return hide();
      if (commerceConfig !== config) {
        commerce = global.SteadiEngravingCommerce.create(config);
        commerceConfig = config;
      }
      if (!Array.isArray(detail.colors)) return hide();
      const pieces = detail.colors.map(color => ({ color: color, name: null }));
      const signature = JSON.stringify([Number(detail.pack), detail.colors]);
      const normalized = commerce.normalizeSelection({ pack: detail.pack, qty: 1, pieces: pieces, ...(signature === lastSignature && groupId ? { groupId: groupId } : {}) });
      const idChanged = variantInput.value !== normalized.variantId;
      const selectionChanged = lastSignature !== signature || groupId !== normalized.groupId;
      if (selectionChanged) {
        const inputs = normalized.pieces.map((piece, index) => property('Steadi ' + (index + 1), piece.color + ' — No engraving'));
        inputs.push(property('Engraving', 'None'));
        inputs.push(property('_steadi_config_v1', JSON.stringify({ v: 1, pack: normalized.pack, pieces: normalized.pieces })));
        inputs.push(property('_steadi_group', normalized.groupId));
        inputs.push(property('_picker', 'v2'));
        inputs.push(property('_steadi_accelerated', '1'));
        properties.replaceChildren(...inputs);
        lastSignature = signature;
        groupId = normalized.groupId;
      }
      syncAttribution();
      variantInput.value = normalized.variantId;
      variantInput.disabled = false;
      wrapper.dataset.pack = String(normalized.pack);
      wrapper.inert = false;
      wrapper.hidden = false;
      wrapper.removeAttribute('aria-hidden');
      if (idChanged) variantInput.dispatchEvent(new global.Event('change', { bubbles: true }));
      return true;
    } catch (_) { return hide(); }
  }
  function guard(event) {
    if (event.type === 'keydown' && !['Enter', ' ', 'Spacebar'].includes(event.key)) return;
    if (!lastDetail || !sync(lastDetail)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }
  for (const event of ['pointerdown', 'keydown', 'click', 'submit']) wrapper.addEventListener(event, guard, true);
  document.addEventListener('steadi:attribution-ready', syncAttribution);
  document.addEventListener('steadi:engraving-assignment-ready', syncAttribution);
  document.addEventListener('visitorConsentCollected', syncAttribution);
  global.addEventListener('storage', event => { if (event.key === 'steadi_spine_v1') syncAttribution(); });
  hide();
  global.SteadiProductExpress = Object.freeze({ sync: sync });
})(window);

